import React from "react";

import FooterAvatai from "../../avatai/FooterAvatai";
import {isInAvataiSite} from "../Utils";

const Footer = () => {
  if (isInAvataiSite())
    return (
      <FooterAvatai />
    );
  else
    return (
      <></>
    );
};

export default Footer;
